import React from 'react'
import styles from './contact.module.css'



// const colorBallPos=[1,2,3,4,5,50,100,150,200,250,301,302,303,304,305,
//                     8,9,10,11,57,62,107,157,112,162,212,262,311,310,309,308,257,207,
//                     14,64,114,164,214,264,314,65,116,167,218,269,320,270,220,170,120,70,20,
//                     22,23,24,25,26,27,28,75,125,175,225,275,325,
//                     31,32,33,80,130,180,230,280,330,84,134,184,234,284,334,231,232,233,
//                     37,38,39,40,41,86,136,186,236,286,337,338,339,340,341,
//                     43,44,45,46,47,48,49,96,146,196,246,296,346,
//                     414,464,514,564,614,664,714,465,516,567,518,469,420,470,520,570,620,670,720,
//                     430,480,530,580,630,680,730,431,432,433,434,435,436,581,582,583,584,585,586,731,732,733,734,735,736]

export default function Contact({position}) {
    // const boxes= new Array(750).fill(" ");
    // const {innerHeight,innerWidth}=useWindowSize();
  return (
    <div className={styles.contact}>
      {/* <div className={styles["con-top"]}>
       <div className={styles.chart}>
         {boxes.map((b,index)=>(
           colorBallPos.includes(index) ? 
           <div key={index} className={styles.colorball} 
            style={{backgroundColor:position < innerHeight ? "yellow" : undefined}}
           ></div>
           :<div key={index} className={styles.ball}></div>
           ))}
       </div>
      </div> */}
      <div className={styles["con-bottom"]}>
          <p className={styles.email}>
            {/* <FontAwesomeIcon icon={faEnvelope} className={styles.icon}/> */}
            <span className={styles.start}>Contact me via...</span><br/>
            aoyama.in.opu@gmail.com
          </p>
      </div> 
    </div>
  )
}
